@import '../../sass/helpers';

::slotted(som-content) {
  --padding-top: 1rem;
  --padding-left: 1rem;
  --padding-right: 1rem;
  --padding-bottom: 1rem;
}

.accordion {
  border-bottom: 1px solid $border-color;
  background: transparent;

  &--open {
    &.accordion {
      &__button {
        background-color: $light-gray;

        // Only add multiply when open but not focused.  We don't want to apply multiply to $smoke
        &:not(:focus-visible) {
          mix-blend-mode: multiply;
        }
      }
    }
  }
  &__button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: transparent;
    width: 100%;
    padding: 1.5rem 1rem;
    border: none;

    &:hover {
      background-color: $smoke;
      cursor: pointer;
    }

    &:focus-visible {
      outline: none;
      background-color: $smoke;
      box-shadow: inset 0px 0px 0px 2px $primary;
      cursor: pointer;
    }
  }
  &__headline {
    display: flex;
    align-items: center;

    &-icon {
      @include text-type(3);
      color: $primary;
      margin-right: .5rem;
      display: inline-block;
    }

    &-label {
      @include font-weight($font-weight-normal);
      @include text-type(4);
      font-family: $font-family-base;
      color: $header-copy;
      padding-right: 1rem;
      text-align: left;
    }
  }

  &__icon {
    font-size: 1.5rem;
    color: $primary;
    min-width: 1.5rem;
  }
  &__content {
    display: none;
  }
}
